











































import { Component, Vue, Watch } from "vue-property-decorator";

import { days_of_week } from "@/config/dailySchedule/schedule-by-day.config.json";
import { ITimetable, ITimetableBlob } from "@/@types/timetable/timetable";
import { preferred_language } from "@/config/languags.config.json";
import { downloadImage } from "@/services/getImage";
import { pics } from "@/config/host.config";

import LanguagesButtons from "@/components/buttons/languages-buttons.vue";
import DailyScheduleForm from "@/components/forms/daily_schedule/daily-schedule-form.vue";
import DailyScheduleDemo from "@/components/demo/daily_schedule/daily-schedule-demo.vue";

@Component({
  components: { LanguagesButtons, DailyScheduleDemo, DailyScheduleForm },
})
export default class Instruction extends Vue {
  change = false;
  locale = preferred_language;
  timetables: Array<ITimetable> = [];
  timetablesDraggable: Array<ITimetableBlob> = [];

  $refs!: {
    timetableForm: DailyScheduleForm;
  };

  updatePoster(poster: Blob, day: string): void {
    const timetable = this.timetablesDraggable.find((el) => el.day == day);
    console.log(timetable);

    if (!timetable)
      this.timetablesDraggable.push({
        day: day,
        image_name: [poster],
      });
    else this.$set(timetable, "image_name", [poster]);
    this.change = true;
  }

  createDemoDraggable(): void {
    for (const day of days_of_week) {
      const timetable = this.timetables.find((el) => el.day == day);
      if (!timetable) continue;

      const file: ITimetableBlob = {
        day: timetable.day.slice(),
        image_name: [],
      };

      if (timetable.image_name.length) {
        const url = pics.download;
        const path = `timetable/${this.locale}/${day}`;
        downloadImage(url, timetable.image_name[0], path).then((img: Blob) => {
          file.image_name.push(new Blob([img]));
        });
      }
      this.timetablesDraggable.push(file);
    }
  }

  async delTimetable(day: string): Promise<void> {
    const url = pics.timetable;
    const lang = this.locale;
    const config = { params: { lang, day } };
    try {
      const delited = await this.$axios.delete(url, config);
      if (delited.status === 200) {
        this.change = true;
        const timetable = this.timetables.find((el) => el.day == day);
        if (!timetable) return;
        timetable.image_name[0] = "";

        const dr = this.timetablesDraggable.find((el) => el.day == day);
        if (!dr) return;
        dr.image_name = [];

        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      }
    } catch (error) {
      console.log(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async replaceTimeTableContent(timetableData: ITimetableBlob): Promise<void> {
    if (!timetableData.image_name.length) {
      this.delTimetable(timetableData.day);
      return;
    }
    const url = pics.timetable;
    const params = { lang: this.locale };

    const file: File = new File([timetableData.image_name[0]], "i.jpg", {
      type: "img/jpg",
    });

    let formData: FormData = new FormData();
    formData.append("poster", file);

    try {
      const res = await this.$axios.put(url, formData, { params });
      if (res.status == 200) {
        this.change = false;
      }
    } catch (error) {
      console.log(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async changeImg(): Promise<void> {
    this.$refs.timetableForm.onReset();
    for (const timetable of this.timetablesDraggable) {
      await this.replaceTimeTableContent(timetable);
    }
  }

  @Watch("locale")
  async startTimetable(): Promise<void> {
    const url = pics.timetable;
    const config = { params: { lang: this.locale } };
    try {
      const res = await this.$axios.get(url, config);
      if (res.status === 200) {
        this.timetables = res.data;
        this.createDemoDraggable();
      }
    } catch (error) {
      console.log(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  mounted(): void {
    this.startTimetable();
  }
}
